import useSize from '@react-hook/size';
import React from 'react';

export default function WithWidth({children}: {children: (width: number) => React.ReactNode}) {
  const vizContainerRef = React.useRef(null);
  const [width] = useSize(vizContainerRef);

  return (
    <div ref={vizContainerRef} className="h-full w-full">
      {!!width && children(width)}
    </div>
  );
}
